module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-2.77c75d2f.png";